export const SMALL_FILE_SIZE = 1e8;
export const MEDIUM_FILE_SIZE = 1e9;
export const LARGE_FILE_SIZE = 5e9;
